import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { MessageSquare } from 'lucide-react';

export default function FeedbackConfirmationDialog({ open, onConfirm, onCancel }) {
  const { t } = useTranslation('common');

  return (
    <AlertDialog open={open} onOpenChange={onCancel}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center gap-2">
            <MessageSquare className="h-5 w-5 text-primary" />
            {t('productFeedback.confirmation.title')}
          </AlertDialogTitle>
          <AlertDialogDescription className="space-y-3 text-left">
            <p className="text-foreground font-medium">
              {t('productFeedback.confirmation.subtitle')}
            </p>
            <div className="bg-muted border border-border rounded-lg p-3 space-y-2">
              <div className="flex items-center gap-2 text-sm">
                <span>🐛</span>
                <span><strong className="text-foreground">{t('productFeedback.confirmation.bugLabel')}:</strong> {t('productFeedback.confirmation.bugDescription')}</span>
              </div>
              <div className="flex items-center gap-2 text-sm">
                <span>✨</span>
                <span><strong className="text-foreground">{t('productFeedback.confirmation.featureLabel')}:</strong> {t('productFeedback.confirmation.featureDescription')}</span>
              </div>
              <div className="flex items-center gap-2 text-sm">
                <span>📈</span>
                <span><strong className="text-foreground">{t('productFeedback.confirmation.improvementLabel')}:</strong> {t('productFeedback.confirmation.improvementDescription')}</span>
              </div>
            </div>
            <p className="text-sm text-muted-foreground">
              {t('productFeedback.confirmation.footer')}
            </p>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={onCancel}>
            {t('productFeedback.confirmation.cancel')}
          </AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm}>
            {t('productFeedback.confirmation.continue')}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
